import {useDispatch, useSelector} from "react-redux";

import {useAppKitNetwork, useAppKitAccount, useAppKitProvider} from "@reown/appkit/react";
import {formatUnits} from "ethers/lib/utils";
import {ethers} from "ethers";

import {setBalance} from "store/AuthV2/AuthV2Slice";
import {CHAIN_TO_PARAMS_MAP} from "web3/chains";
import {ERC20} from "web3/ABI";

export const useConnectedWallet = () => {
    const dispatch = useDispatch()

    const {chainId: connectedChainId} = useAppKitNetwork()
    const {walletProvider} = useAppKitProvider("eip155");
    const {isConnected, address} = useAppKitAccount();

    const {userData} = useSelector(state => state.authV2.signIn)

    const isConnectedAddressCorrect = userData?.wallet?.toLowerCase() === address?.toLowerCase()

    const getEthBalance = async (address) => {
        let ethBalance = 0
        try {
            const walletConnectProvider = new ethers.providers.Web3Provider(walletProvider)

            const balance = await walletConnectProvider.getBalance(address)
            ethBalance = Number(formatUnits(balance.toString()))

        } catch {
            ethBalance = 0
        }

        dispatch(setBalance({currencyType: "ethBalance", balance: ethBalance}))
    }

    const getKompeteBalance = async (address, chainId) => {
        let kompeteBalance = 0
        try {
            const {addresses, paymentDecimals, rpcURL} = CHAIN_TO_PARAMS_MAP[chainId ?? connectedChainId]

            const provider = new ethers.providers.JsonRpcProvider(rpcURL)
            const contract = new ethers.Contract(addresses.PAYMENT_ADDRESS, ERC20, provider)

            const getKompeteBalance = await contract.balanceOf(address)

            kompeteBalance = Number(formatUnits(getKompeteBalance, paymentDecimals))
        } catch {
            kompeteBalance = 0
        }

        dispatch(setBalance({currencyType: "kompeteBalance", balance: kompeteBalance}))
    }

    return {
        isConnectedAddressCorrect,
        connectedChainId,
        isConnected,
        address,
        getKompeteBalance,
        getEthBalance,
    }
}